module.exports = __webpack_public_path__ + "img/search.e83c2176.svg";